import { render, staticRenderFns } from "./DemoVideoModal.vue?vue&type=template&id=3fef74bf"
import script from "./DemoVideoModal.vue?vue&type=script&lang=js"
export * from "./DemoVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports